import {Component, OnInit} from '@angular/core';
import {TemplateCopyService} from '~/app/core/services/template-copy.service';
import {ItemGLSetup} from '@model/ItemGLSetup';
import {State} from '@progress/kendo-data-query';
import {Template} from '@model/Template';
import {Store} from '@model/Store';
import { LoadingIndicatorHelper } from '~/app/core/services/loading-indicator-helper';

@Component({
  selector: 'app-preview-template-copy',
  templateUrl: './preview-template-copy.component.html',
  styleUrls: ['./preview-template-copy.component.scss']
})
export class PreviewTemplateCopyComponent implements OnInit {
  public gridData: any = [];
  public mySelection: ItemGLSetup[] = [];
  public selectedCallback = (args) => args.dataItem;
  public templates: Template[] = [];
  public selectedTargetStore: Store = new Store();
  public selectedTemplateStore: Store = new Store();
  public targetSegmentMap: Map<number, String> = new Map();
  public templateSegmentMap: Map<number, String> = new Map();
  newExportGL: string = '';
  public gridState: State = {
    sort: [],
    skip: 0,
    take: 20
  };

  constructor(public templateCopyService: TemplateCopyService,
              public loadingIndicator: LoadingIndicatorHelper) {
  }


  ngOnInit() {
    this.populateTemplateGrid().then(r => r);
  }

  async populateTemplateGrid() {
    this.loadingIndicator.show();

    this.templateCopyService.selectedTemplateStore.subscribe(templateStore => this.selectedTemplateStore = templateStore);
    this.templateCopyService.selectedTargetStore.subscribe(targetStore => this.selectedTargetStore = targetStore);
    this.templateCopyService.targetSegmentMap.subscribe(targetSegmentMap => this.targetSegmentMap = targetSegmentMap);
    this.templateCopyService.templateSegmentMap.subscribe(templateSegmentMap => this.templateSegmentMap = templateSegmentMap);

    if (this.selectedTemplateStore !== undefined && this.selectedTemplateStore.storeID != undefined) {
      this.templates = await this.templateCopyService.preview('A', this.selectedTemplateStore.chainID, this.selectedTemplateStore.hoID, this.selectedTemplateStore.storeID, this.targetSegmentMap, this.templateSegmentMap);
      console.log('this is where: ', this.templates);
      this.mySelection = [];
      if (this.templates != null && this.templates.length > 0) {
        this.gridData = this.templates;
        this.gridData.total = this.templates.length;
      }
    }
    this.loadingIndicator.hide();
  }
}
